



















import AbpBase from "@/lib/abpbase"
import {Component} from "vue-property-decorator"
import {GetBloodStatistics, GetMachineRepairStatistics} from "@/api/report"

@Component({
	components:{}
})
export default class PatientStatistics extends AbpBase{
	loading = false
	date:any = new Date()
	data1:any = []
	data2:any = []
	query:any = {
		LssPressure: 90,
		LszPressure: 60,
		HssPressure: 140,
		HszPressure: 90,
	}
	created(){
		this.getData()
	}
	private async getData() {
		this.loading = true
		let query:any = {}
		if (typeof this.date === 'object') {
			query.Year = this.date.getFullYear()
		} else {
			query.Year = this.date
		}
		let res = await GetBloodStatistics(query)
		this.data1 = res.objects.beforeBloodItems
		this.data2 = res.objects.afterBloodItems
		this.loading = false
	}
	columns1 = [
		{
			title: '日期',
			key: 'date'
		},
		{
			title: '低血压人数',
			key: 'lPressureCount'
		},
		{
			title: '正常血压人数',
			key: 'pressureCount'
		},
		{
			title: '高血压人数',
			key: 'hPressureCount'
		},
		{
			title: '总计',
			key: 'total'
		},

	]
	columns2 = [
		{
			title: '日期',
			key: 'date'
		},
		{
			title: '低血压人数',
			key: 'lPressureCount'
		},
		{
			title: '正常血压人数',
			key: 'pressureCount'
		},
		{
			title: '高血压人数',
			key: 'hPressureCount'
		},
		{
			title: '总计',
			key: 'total'
		},

	]
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/report/bloodStatistics/index.vue